// eslint-disable no-lone-blocks

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useGetMatchRosterFullQuery } from 'common/store/modules/api/cfs-api';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { ToggleInput } from 'common/react/components/ToggleInput';
import { getTranslation } from 'common/react/utils/translations';
import { TASkeleton } from './TASkeleton';
import { TeamAnnouncementsContent } from './TeamAnnouncementsContent';

export const TeamAnnouncements = ({ pid, teamDisplay }) => {
    const matchId = pid;
    const initialTeamDisplay = teamDisplay;
    const [viewMode, setViewMode] = useState('field');

    // Fetch the match roster data using RTK query
    const { data: matchRosterData } = useGetMatchRosterFullQuery({
        matchId: matchId
    });

    const displayHome =
        teamDisplay === 'home' ||
        teamDisplay === 'both' ||
        initialTeamDisplay === 'home' ||
        initialTeamDisplay === 'both';
    const displayAway =
        teamDisplay === 'away' ||
        teamDisplay === 'both' ||
        initialTeamDisplay === 'away' ||
        initialTeamDisplay === 'both';

    return (
        <>
            <div className="team-announcements__content-body">
                <div className="team-announcements__toggle-wrapper">
                    <ToggleInput
                        id="data-type-toggle"
                        value={viewMode}
                        onChange={(value) => setViewMode(value)}
                        options={[
                            {
                                label: getTranslation(
                                    'label.teamannouncements.fieldView'
                                ),
                                value: 'field'
                            },
                            {
                                label: getTranslation(
                                    'label.teamannouncements.listView'
                                ),
                                value: 'list'
                            }
                        ]}
                    />
                </div>
                {matchRosterData ? (
                    <TeamAnnouncementsContent
                        viewMode={viewMode}
                        matchRosterData={matchRosterData}
                        initialTeamDisplay={initialTeamDisplay}
                        displayHome={displayHome}
                        displayAway={displayAway}
                    />
                ) : (
                    <TASkeleton />
                )}
            </div>
            <div className="team-announcements__last-updated">
                <SvgIcon
                    icon="info-circle"
                    className="team-announcements__last-updated-icon"
                />
                <p className="team-announcements__last-updated-details">
                    <span className="team-announcements__last-updated-label">
                        {PULSE.I18N.lookup('label.teamlineups.lastUpdated')}
                    </span>{' '}
                    <span className="team-announcements__last-updated-time">
                        {moment(
                            matchRosterData?.matchRoster?.lastUpdated
                        ).format('h:mm a dddd, MMMM DD, YYYY')}
                    </span>
                </p>
            </div>
        </>
    );
};

TeamAnnouncements.propTypes = {
    pid: PropTypes.string,
    teamDisplay: PropTypes.string
};
